import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'loading-screen',
  templateUrl: 'loading.html',
})
export class LoadingPage {

}


// WEBPACK FOOTER //
// ./src/pages/loading/loading.ts